import { Injectable } from '@angular/core';
import { IFilter } from 'sol-request-angular/dist/comunicacao/interfaces/IFilter';
import { Quark, HttpGet, Url, HttpResponse, HttpPost, JSONData, HttpPut } from 'sol-request-angular/dist/comunicacao';
import { environment } from 'src/environments/environment';
import { TipoVeiculo } from '@tivic-team/manager-ts/dist/fta';


@Injectable()
export class TipoVeiculoController{

    constructor() {}

	async get(cdTipoVeiculo:number):Promise<TipoVeiculo>{		
		let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'fta/veiculos/tipos/:cdTipoVeiculo',
					environment: environment,
					pathParams: new JSONData({cdTipoVeiculo: cdTipoVeiculo})
				}),
			}),
			new HttpResponse(
			  new TipoVeiculo()
			)
		);
		return await quark.call();
    }

    async getAllTypesVehicles( ):Promise< Array<TipoVeiculo> > {
        let quark = new Quark( 
            new HttpGet({ 
                url: new Url({ 
                    id: 'fta/veiculos/tipos',
                    environment: environment
                })               
            }),
            new HttpResponse(
                new Array<TipoVeiculo[]>()
            )
        )
        
        return await quark.call();
    }
    
    async find(filtros?:IFilter):Promise<Array<TipoVeiculo>>{
        let quark = new Quark(
            new HttpGet({
                url:new Url({
                    id: 'fta/veiculos/tipos',
                    environment: environment,
                    filter: filtros
                }),
            }),
            new HttpResponse(
                new Array<TipoVeiculo>()
            )
        );
        return await quark.call();
    }

    async create( tipoVeiculo: TipoVeiculo ): Promise<TipoVeiculo> {
        let quark = new Quark(
            new HttpPost({
                url: new Url({
                    id: 'fta/veiculos/tipos',
                    environment: environment
                }),
                data: new JSONData( tipoVeiculo )
            }),
            new HttpResponse(
                new TipoVeiculo()
            )
        );

        return await quark.call();

    }

    async update( tipoVeiculo: TipoVeiculo ): Promise< TipoVeiculo > {
        let quark = new Quark(
            new HttpPut({
                url: new Url({
                    id: 'fta/veiculos/tipos/:cdTipoVeiculo',
                    environment: environment,
                    pathParams: new JSONData({ cdTipoVeiculo: tipoVeiculo.cdTipoVeiculo }),
                }),
                data: new JSONData( tipoVeiculo )
            }),
            new HttpResponse(
                new TipoVeiculo()
            )
        );
        return await quark.call();
    }
}